module.exports = __webpack_public_path__ + "fonts/Azonix.cdfe47b3.otf";